module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-context"
  }, [_c('div', {
    staticClass: "setting-main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('staticSettings')) + " (" + _vm._s(_vm.settingsData.glucose_unit) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-main-context"
  }, [_c('div', {
    staticClass: "item1 overflow",
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'es12': _vm.isEs || _vm.isFr
    }
  }, [_c('span', {
    staticClass: "alert-option",
    class: {
      'it3': _vm.isIt, 'po3': _vm.isPo, 'du2': _vm.isDu, 'de12': _vm.isDe, 'es13': _vm.isEs || _vm.isSw, 'fr13': _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('showAlert')))]), _vm._v(" "), _c('div', {
    staticClass: "alert-left",
    class: {
      'alert-choose': _vm.alertOption
    },
    on: {
      "click": function($event) {
        _vm.changeAlarm(0)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('On')))])]), _vm._v(" "), _c('div', {
    staticClass: "alert-right",
    class: {
      'alert-choose': !_vm.alertOption
    },
    on: {
      "click": function($event) {
        _vm.changeAlarm(1)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Off')))])])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "item1 overflow",
    class: {
      'it2': _vm.isIt, 'po2': _vm.isPo, 'es12': _vm.isEs || _vm.isFr
    }
  }, [_c('span', {
    staticClass: "alert-option",
    class: {
      'it3': _vm.isIt, 'po3': _vm.isPo, 'du2': _vm.isDu, 'de12': _vm.isDe, 'es13': _vm.isEs || _vm.isSw, 'fr13': _vm.isFr || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('t1215_Show_Glucose_Value')))]), _vm._v(" "), _c('div', {
    staticClass: "alert-left",
    class: {
      'alert-choose': _vm.glucoseOption
    },
    on: {
      "click": function($event) {
        _vm.changeGlucose(0)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('On')))])]), _vm._v(" "), _c('div', {
    staticClass: "alert-right",
    class: {
      'alert-choose': !_vm.glucoseOption
    },
    on: {
      "click": function($event) {
        _vm.changeGlucose(1)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Off')))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('p', {
    class: {
      'zh9': !_vm.isEn, 'de9': _vm.isDe
    }
  }, [_vm._v(_vm._s(_vm.$t('glucoseTarget')))]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('overall')))]), _c('span', [_vm._v(_vm._s(_vm.$t('Hypoglycemia')))])]), _vm._v(" "), _c('div', {
    staticClass: "item-right",
    class: {
      'zh10': !_vm.isEn, 'it9': _vm.isIt, 'po9': _vm.isPo
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low),
      expression: "settingsData.blos_low"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high),
      expression: "settingsData.blos_high"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), (_vm.settingsData != null) ? _c('span', {
    staticClass: "hyp"
  }, [_vm._v(_vm._s(_vm.settingsData.hypo))]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "titleLabl"
  }, [_c('p', {
    staticClass: "spe-label",
    class: {
      'zh6': !_vm.isEn, 'de6': _vm.isDe
    }
  }, [_vm._v(_vm._s(_vm.$t('glucoseTarget')))]), _vm._v(" "), _c('p', {
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'de7': _vm.isDe, 'it7': _vm.isIt, 'po7': _vm.isPo || _vm.isFr, 'sw7': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('timePeriod')))]), _vm._v(" "), _c('p', {
    staticClass: "spe1-label1",
    class: {
      'zh8': !_vm.isEn, 'es8': _vm.isEs, 'de8': _vm.isDe, 'po8': _vm.isPo || _vm.isFr, 'sw8': _vm.isSw || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('postMeal')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "titleLab2"
  }, [_c('span', {
    staticClass: "spe-labe2",
    class: {
      'zh4': !_vm.isEn, 'es4': _vm.isEs, 'de4': _vm.isDe, 'it4': _vm.isIt, 'du4': _vm.isDu
    }
  }, [_vm._v(_vm._s(_vm.$t('Low')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('High')))]), _vm._v(" "), _c('span', {
    staticClass: "largeSpace",
    class: {
      'it6': _vm.isIt, 'po6': _vm.isPo
    }
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _c('span', {
    class: {
      'fr6': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('span', {
    staticClass: "largeSpace1",
    class: {
      'zh5': !_vm.isEn, 'es5': _vm.isEs, 'it6': _vm.isIt, 'po5': _vm.isPo, 'fr7': _vm.isFr
    }
  }, [_vm._v(_vm._s(_vm.$t('From')))]), _c('span', [_vm._v(_vm._s(_vm.$t('To')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_b),
      expression: "settingsData.blos_low_before_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_b),
      expression: "settingsData.blos_high_before_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_b),
      expression: "settingsData.blos_low_after_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_b),
      expression: "settingsData.blos_high_after_b"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_b = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '10:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.btime1_s),
      callback: function($$v) {
        _vm.settingsData.btime1_s = $$v
      },
      expression: "settingsData.btime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '06:00',
        step: '00:15',
        end: '10:00',
        minTime: _vm.settingsData.btime1_s
      }
    },
    model: {
      value: (_vm.settingsData.btime1_e),
      callback: function($$v) {
        _vm.settingsData.btime1_e = $$v
      },
      expression: "settingsData.btime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      }
    },
    model: {
      value: (_vm.settingsData.afterb_s),
      callback: function($$v) {
        _vm.settingsData.afterb_s = $$v
      },
      expression: "settingsData.afterb_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '01:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afterb_s
      }
    },
    model: {
      value: (_vm.settingsData.afterb_e),
      callback: function($$v) {
        _vm.settingsData.afterb_e = $$v
      },
      expression: "settingsData.afterb_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_l),
      expression: "settingsData.blos_low_before_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_l),
      expression: "settingsData.blos_high_before_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_l),
      expression: "settingsData.blos_low_after_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_l),
      expression: "settingsData.blos_high_after_l"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_l = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '11:00',
        step: '00:15',
        end: '15:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.ltime1_s),
      callback: function($$v) {
        _vm.settingsData.ltime1_s = $$v
      },
      expression: "settingsData.ltime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '11:00',
        step: '00:15',
        end: '15:00',
        minTime: _vm.settingsData.ltime1_s
      }
    },
    model: {
      value: (_vm.settingsData.ltime1_e),
      callback: function($$v) {
        _vm.settingsData.ltime1_e = $$v
      },
      expression: "settingsData.ltime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.afterl_s),
      callback: function($$v) {
        _vm.settingsData.afterl_s = $$v
      },
      expression: "settingsData.afterl_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '1:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afterl_s
      }
    },
    model: {
      value: (_vm.settingsData.afterl_e),
      callback: function($$v) {
        _vm.settingsData.afterl_e = $$v
      },
      expression: "settingsData.afterl_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-2",
    class: {
      'zh1': !_vm.isEn, 'de2': _vm.isDe, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Before')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('After')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_before_s),
      expression: "settingsData.blos_low_before_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_before_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_before_s),
      expression: "settingsData.blos_high_before_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_before_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_after_s),
      expression: "settingsData.blos_low_after_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_after_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLowAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_after_s),
      expression: "settingsData.blos_high_after_s"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_after_s = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHighAfter), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '17:00',
        step: '00:15',
        end: '21:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.stime1_s),
      callback: function($$v) {
        _vm.settingsData.stime1_s = $$v
      },
      expression: "settingsData.stime1_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '17:00',
        step: '00:15',
        end: '21:00',
        minTime: _vm.settingsData.stime1_s
      }
    },
    model: {
      value: (_vm.settingsData.stime1_e),
      callback: function($$v) {
        _vm.settingsData.stime1_e = $$v
      },
      expression: "settingsData.stime1_e "
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item1-5 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '00:30',
        step: '00:15',
        end: '2:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.afters_s),
      callback: function($$v) {
        _vm.settingsData.afters_s = $$v
      },
      expression: "settingsData.afters_s "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "placeholder": "Time",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '1:00',
        step: '00:15',
        end: '4:00',
        minTime: _vm.settingsData.afters_s
      }
    },
    model: {
      value: (_vm.settingsData.afters_e),
      callback: function($$v) {
        _vm.settingsData.afters_e = $$v
      },
      expression: "settingsData.afters_e "
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.$t('Hours')))])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('div', {
    staticClass: "item1-1"
  }, [_c('span', {
    staticClass: "night",
    class: {
      'es3': _vm.isEs
    }
  }, [_vm._v(_vm._s(_vm.$t('night')))])]), _vm._v(" "), _c('div', {
    staticClass: "item1-3 spe-ietm",
    class: {
      'zh2': !_vm.isEn, 'es2': _vm.isEs
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_low_night),
      expression: "settingsData.blos_low_night"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_low_night = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgLow), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settingsData.blos_high_night),
      expression: "settingsData.blos_high_night"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.settingsData.blos_high_night = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sgHigh), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "item1-4 Setting-time"
  }, [_c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '22:00',
        step: '00:15',
        end: '24:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.etime1_s),
      callback: function($$v) {
        _vm.settingsData.etime1_s = $$v
      },
      expression: "settingsData.etime1_s  "
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "tiny-hr"
  }), _vm._v(" "), _c('el-time-select', {
    attrs: {
      "size": "mini",
      "clearable": false,
      "editable": false,
      "picker-options": {
        start: '05:00',
        step: '00:15',
        end: '07:00'
      },
      "placeholder": "Time"
    },
    model: {
      value: (_vm.settingsData.etime1_e),
      callback: function($$v) {
        _vm.settingsData.etime1_e = $$v
      },
      expression: "settingsData.etime1_e  "
    }
  })], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr spe-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "setting-operate2"
  }, [_c('button', {
    staticClass: "reset",
    class: {
      'es1': _vm.isEs, 'de1': _vm.isDe, 'it1': _vm.isIt || _vm.isCz, 'po1': _vm.isPo, 'du1': _vm.isDu
    },
    on: {
      "click": _vm.restore
    }
  }, [_vm._v(_vm._s(_vm.$t('Reset')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fe7706e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-template/setting.vue
// module id = 1488
// module chunks = 7